export const degreeNamesList = [
  { name: "--Select--", val: "-", key: 0 },
  { name: "B.A L.L.B. Integrated (5 years)", val: "BALLBI5y", key: 1 },
  { name: "B.A.", val: "BA", key: 2 },
  { name: "B.A.-B.Ed.", val: "BABE", key: 3 },
  { name: "B.B.A", val: "BBA", key: 4 },
  { name: "B.C.A.", val: "BCA", key: 5 },
  { name: "B.Com.", val: "BC", key: 6 },
  { name: "B.El.Ed.", val: "BEE", key: 7 },
  { name: "B.F.A", val: "BFA", key: 8 },
  { name: "B.J.M.C", val: "BJMC", key: 9 },
  { name: "B.M.L.T.", val: "BMLT", key: 10 },
  { name: "B.M.M.", val: "BMM", key: 11 },
  { name: "B.O.T", val: "BOT", key: 12 },
  { name: "B.P.E.S.", val: "BPES", key: 13 },
  { name: "B.P.T", val: "BPT", key: 14 },
  { name: "B.Sc (Computer Science)", val: "BSCS", key: 15 },
  { name: "B.Sc (Nursing)", val: "BSN", key: 16 },
  {
    name: "B.Sc (Physical Education, Health Education and Sports)",
    val: "BSPEHEaS",
    key: 17,
  },
  {
    name: "B.Sc Home Science (Clinical Nutrition and Dietetics)",
    val: "BSHSCNaD",
    key: 18,
  },
  { name: "B.Sc Hons(Biotechnology)", val: "BSHB", key: 19 },
  { name: "B.Sc(Microbiology)", val: "BSM", key: 20 },
  { name: "B.Sc.", val: "BS", key: 21 },
  { name: "B.Sc. Hons(Microbiology)", val: "BSHM", key: 22 },
  { name: "B.Sc.(Biotechnology)", val: "BSB", key: 23 },
  { name: "B.Sc.(Home Science)", val: "BSHS", key: 24 },
  { name: "B.Tech-M.B.A. (Integrated)", val: "BTMBAI", key: 25 },
  { name: "BRDIT", val: "B", key: 26 },
  { name: "BSc. Ag.", val: "BA", key: 27 },
  { name: "Certificate of Proficiency in French", val: "CoPiF", key: 28 },
  { name: "Certificate of Proficiency in Russian", val: "CoPiR", key: 29 },
  { name: "Diploma in French Language", val: "DiFL", key: 30 },
  { name: "Diploma in Russian Language", val: "DiRL", key: 31 },
  { name: "M.Tech. Integrated in Biotech.", val: "MTIiB", key: 32 },
  {
    name: "M.Tech. Integrated in Electronics and Telecomm",
    val: "MTIiEaT",
    key: 33,
  },
  { name: "B.Lib./B.L.I.Sc.", val: "BLBLIS", key: 34 },
  { name: "M.Lib/M.L.I.Sc", val: "MLMLIS", key: 35 },
  { name: "B.P.Ed.", val: "BPE", key: 36 },
  { name: "L.L.B (3 years)", val: "LLB3y", key: 37 },
  { name: "L.L.M.", val: "LLM", key: 38 },
  { name: "M.A.", val: "MA", key: 39 },
  { name: "M.B.E", val: "MBE", key: 40 },
  { name: "M.Com.", val: "MC", key: 41 },
  { name: "M.ED", val: "ME", key: 42 },
  { name: "M.F.A", val: "MFA", key: 43 },
  { name: "M.B.A. (I.B.)", val: "MBAIB", key: 44 },
  { name: "M.L.I.Sc.", val: "MLIS", key: 45 },
  { name: "M.O.T", val: "MOT", key: 46 },
  { name: "M.P.A", val: "MPA", key: 47 },
  { name: "M.P.E.S.", val: "MPES", key: 48 },
  { name: "M.P.ED", val: "MPE", key: 49 },
  { name: "M.P.T", val: "MPT", key: 50 },
  { name: "M.Phil", val: "MP", key: 51 },
  { name: "M.Sc (Biotechnology)", val: "MSB", key: 52 },
  { name: "M.Sc (Nursing)", val: "MSN", key: 53 },
  {
    name: "M.Sc Home Science (Clothing and Textile)",
    val: "MSHSCaT",
    key: 54,
  },
  { name: "M.Sc Home Science (Home Mgmt.)", val: "MSHSHM", key: 55 },
  { name: "M.Sc Home Science (Human Development)", val: "MSHSHD", key: 56 },
  { name: "M.Sc Home Science(Food and Nutrition)", val: "MSHSFaN", key: 57 },
  { name: "M.Sc.", val: "MS", key: 58 },
  { name: "M.Sc. Ag.", val: "MSA", key: 59 },
  { name: "M.Sc. Applied Microbiology", val: "MSAM", key: 60 },
  { name: "M.Sc. Biochemistry", val: "MSB", key: 61 },
  { name: "M.Sc. Bioinformatics", val: "MSB", key: 62 },
  { name: "M.Sc. Computer Science", val: "MSCS", key: 63 },
  { name: "M.Sc. in Environmental Science", val: "MSiES", key: 64 },
  {
    name: "M.Sc. in Polymer Science and Chemical Technology (PSCT)",
    val: "MSiPSaCTP",
    key: 65,
  },
  { name: "M.Sc. in Toxicology (Campus - CBCS)", val: "MSiTCC", key: 66 },
  { name: "M.Sc. Information Science", val: "MSIS", key: 67 },
  { name: "M.Sc. Microbiology", val: "MSM", key: 68 },
  { name: "Master in Social Work", val: "MiSW", key: 69 },
  { name: "MJMC", val: "M", key: 70 },
  { name: "P.G. Dip. In R.S. And GIS", val: "PGDIRSAG", key: 71 },
  { name: "Post Basic B.Sc (Nursing)", val: "PBBSN", key: 72 },
  { name: "B.Voc. (Yoga)", val: "BVY", key: 73 },
  { name: "B.Voc. (Clinical Psychology)", val: "BVCP", key: 74 },
  { name: "B.Voc. (IT)", val: "BVI", key: 75 },
  { name: "M.Sc. In Medical Microbiology", val: "MSIMM", key: 76 },
  {
    name: "B.Sc.(Food Microbiology, Safety and Quality Control)",
    val: "BSFMSaQC",
    key: 77,
  },
  { name: "M.Sc. Microbiology (Campus - CBCS)", val: "MSMCC", key: 78 },
  { name: "B.Sc. (Honors)", val: "BSH", key: 79 },
  { name: "B.A. (Honors)", val: "BAH", key: 80 },
  { name: "B.Tech.", val: "BT", key: 81 },
  { name: "B.D.S.", val: "BDS", key: 82 },
  { name: "M.B.B.S.", val: "MBBS", key: 83 },
  { name: "M.A. (Campus - CBCS)", val: "MACC", key: 84 },
  { name: "M.Sc. (Campus - CBCS)", val: "MSCC", key: 85 },
  { name: "B.A.M.S.", val: "BAMS", key: 86 },
  {
    name: "Bachelor of Financial &amp; Investment Analysis",
    val: "BoFaIA",
    key: 87,
  },
  { name: "B.Pharma", val: "BP", key: 88 },
  { name: "M.B.A.", val: "MBA", key: 89 },
  { name: "B.E.", val: "BE", key: 90 },
  { name: "Bachelor of Architecture", val: "BoA", key: 91 },
  { name: "Bachelor of Hotel Management", val: "BoHM", key: 92 },
  { name: "B.Sc.(Chemistry) Hons. (Campus - CBCS)", val: "BSCHCC", key: 93 },
  { name: "B.B.A. (Campus)", val: "BBAC", key: 94 },
  { name: "B.P.E.", val: "BPE", key: 95 },
  { name: "M.C.A.", val: "MCA", key: 96 },
  { name: "B.A. (Evening)", val: "BAE", key: 97 },
  { name: "B.Com. (Evening)", val: "BCE", key: 98 },
  { name: "B.Sc. (Evening)", val: "BSE", key: 99 },
  { name: "BSc. Ag. (Evening)", val: "BAE", key: 100 },
  { name: "Bachelor of Education (B.Ed.)", val: "BoEBE", key: 101 },
  { name: "B.Com. (Hons) Campus", val: "BCHC", key: 102 },
  { name: "M.I.B.", val: "MIB", key: 103 },
  { name: "M.B.A. (Hospital Management)", val: "MBAHM", key: 104 },
  {
    name: "P.G. Diploma in Psychological Counseling",
    val: "PGDiPC",
    key: 105,
  },
  { name: "M.B.A. (Dual Specialization)", val: "MBADS", key: 106 },
  { name: "M.C.A. Year-2 (Lateral Entry)", val: "MCAY2LE", key: 107 },
  { name: "B.Tech. Year-2 (Lateral Entry)", val: "BTY2LE", key: 108 },
  { name: "Polytechnic", val: "P", key: 109 },
  { name: "B.Sc. (I.T.)", val: "BSIT", key: 110 },
  { name: "M.Tech.", val: "MT", key: 111 },
  { name: "Bachelor of Social Work (BSW)", val: "BoSWB", key: 112 },
  {
    name: "M.B.A. (Hospital Administration) 5 Years Integrated Programme",
    val: "MBAHA5YIP",
    key: 113,
  },
  { name: "B.Sc. (Hons)", val: "BSH", key: 114 },
  { name: "B.B.A. L.L.B. (5 years)", val: "BBALLB5y", key: 115 },
  {
    name: "Post Graduate Diploma in Management(Finance)",
    val: "PGDiMF",
    key: 116,
  },
  { name: "B.U.M.S.", val: "BUMS", key: 117 },
  { name: "BSc. Ag. (Hons)", val: "BAH", key: 118 },
  {
    name: "Post Graduate Diploma in Yoga Education",
    val: "PGDiYE",
    key: 119,
  },
  { name: "M.Sc. Ag. (Campus - CBCS)", val: "MSACC", key: 120 },
  {
    name: "M.Sc. Ag. (Food Science &amp; Technology)",
    val: "MSAFSaT",
    key: 121,
  },
  { name: "M.Sc. Ag. (Plant Protection)", val: "MSAPP", key: 122 },
  {
    name: "M.Sc. Ag. (Seed Science &amp; Technology)",
    val: "MSASSaT",
    key: 123,
  },
  { name: "M.Sc. Ag. (Entomology)", val: "MSAE", key: 124 },
  { name: "M.Sc. Ag. (Plant Pathology)", val: "MSAPP", key: 125 },
  { name: "B.SC(OPTOMETRY)", val: "BSO", key: 126 },
  { name: "B.Sc. (Nautical Science)", val: "BSNS", key: 127 },
  { name: "B.Com. LL.B. Integrated (5 years)", val: "BCLBI5y", key: 128 },
  { name: "B.P.T. (Lateral Entry)", val: "BPTLE", key: 129 },
  { name: "B.M.L.T. (Lateral Entry)", val: "BMLTLE", key: 130 },
  { name: "BRDIT (Lateral Entry)", val: "BLE", key: 131 },
];
